import { render, staticRenderFns } from "./PageNumberLinks.vue?vue&type=template&id=73d39f5c&scoped=true&"
import script from "./PageNumberLinks.vue?vue&type=script&lang=js&"
export * from "./PageNumberLinks.vue?vue&type=script&lang=js&"
import style0 from "./PageNumberLinks.vue?vue&type=style&index=0&id=73d39f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d39f5c",
  null
  
)

export default component.exports